import { exportTimeout } from '../constants/Export';
import { apiClient } from '../utils/apiClient';
import {
  RequestHeaderKeyTypes,
  RequestHeaderValueTypes,
} from '../constants/RequestHeaderTypes';
import { isResponseError } from '../models/apiClient';

const makeExportRequest = async <T>(endpoint: string, payload?: T): Promise<Blob | null> => {
  const { data } = await apiClient.post(endpoint, payload, {
    timeout: exportTimeout,
    headers: {
      [RequestHeaderKeyTypes.RESPONSE_TYPE]: RequestHeaderValueTypes.BLOB,
    },
  });

  if (isResponseError(data)) {
    return null;
  }

  return data;
};

export { makeExportRequest };
